import {useI18n} from '@yandex-delivery/core/i18n'

import type {ButtonProps} from './ErrorScreen'

type Props = {
  text?: string
  buttonProps?: ButtonProps
}

const RELOAD_PAGE_ACTION = () => {
  window.location.reload()
}

export function useScreenParams({buttonProps, text}: Props) {
  const i18n = useI18n()

  const errorText = text || i18n('tariffs-v3.error.default', 'Не загрузились данные о тарифе')
  const buttonText = buttonProps?.text || i18n('tariffs-v3.error.button.default', 'Обновить страницу')
  const action = buttonProps?.action || RELOAD_PAGE_ACTION
  const view = buttonProps?.view || 'default'

  return {
    errorText,
    buttonText,
    action,
    view,
  }
}
